import React from "react";
import { useI18n } from "../i18n/I18nProvider";

export default function LangSwitcher({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase ${className}`} data-testid="lang-switcher">
      <button
        data-testid="lang-fr"
        onClick={() => setLang("fr")}
        data-cursor="FR"
        className={`transition-colors ${lang === "fr" ? "text-ink-100" : "text-ink-500 hover:text-ink-300"}`}
      >FR</button>
      <span className="text-ink-500">/</span>
      <button
        data-testid="lang-en"
        onClick={() => setLang("en")}
        data-cursor="EN"
        className={`transition-colors ${lang === "en" ? "text-ink-100" : "text-ink-500 hover:text-ink-300"}`}
      >EN</button>
    </div>
  );
}
